<script>
  import { onMount } from "svelte";

  import CodeMirror from 'codemirror';
	import 'codemirror/lib/codemirror.css';

	import "codemirror/mode/javascript/javascript";
	import "codemirror/mode/python/python";

  import 'codemirror/addon/fold/foldgutter.css';
	import 'codemirror/addon/fold/foldcode';
	import 'codemirror/addon/fold/foldgutter';
	import 'codemirror/addon/fold/brace-fold';
	import 'codemirror/addon/fold/indent-fold';


  export let language = 'javascript';
  export let text = '';
  export let readOnly = false;
	export let color = 'var(--foreground)';
	export let backgroundColor = undefined;

	let mounted = false;
  let editor;
  let textarea;

	$: {
		if (mounted) {
			editor.display.wrapper.style.color = color;
			editor.display.wrapper.style.borderRadius = '10px';
			editor.display.wrapper.style.backgroundColor = backgroundColor || (readOnly? '#fbfbfb' : '');
			editor.display.wrapper.style.borderStyle = 'solid';
			editor.display.wrapper.style.borderWidth = '2px';
			editor.display.wrapper.style.borderColor = '#eee';

			if (editor.getValue() !== text) {
				editor.setValue(text);
			}
		}
	};

  onMount(() => {
		mounted = true;
		editor = CodeMirror.fromTextArea(textarea, {
			lineNumbers: true,
			lineWrapping: false,
			readOnly: readOnly,
			extraKeys: {"Ctrl-B": function(cm){ cm.foldCode(cm.getCursor()); }},
			foldGutter: true,
			gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter"],
			mode:  language,
			lineNumbers: !readOnly,
		});
		editor.on('change', () => {
			text = editor.getValue();
			editor.setSize(null, editor.defaultTextHeight()*(editor.lineCount() + 2));
		});
		window.editor = editor;
	});
</script>

<div>
  <textarea bind:this={textarea}></textarea>
</div>

<style>
  div {
		z-index: 2;
		font-size: 16px;
    text-align: left;
		border-radius: 10px;
  }
</style>
